module.exports = __webpack_public_path__ + "static/media/ov.ce6d1b9b.JPG";